import { pad } from './utils.js'
import { addHours } from 'date-fns'

export function createDp($input, options = {}) {
  return Promise.all([
    import(/* webpackChunkName: 'pikaday' */ 'pikaday')
  ]).then(([Pikaday]) => {
    let [day, month, year] = $input.value.split('/')
    let initialDate = new Date(
      parseInt(year, 10),
      parseInt(month, 10) - 1,
      parseInt(day, 10)
    )

    if (!isValidDate(initialDate)) {
      let d = $input.getAttribute('data-initial')
      if (d) {
        initialDate = addHours(new Date(), parseInt(d, 10))
      }
    }

    if (isValidDate(initialDate)) {
      options.defaultDate = initialDate
      options.setDefaultDate = true
    }

    let pika = new Pikaday({
      field: $input,
      trigger: document.getElementById($input.getAttribute('data-trigger')),
      toString(date) {
        return `${pad('00', date.getDate())}/${pad(
          '00',
          date.getMonth() + 1
        )}/${date.getFullYear()}`
      },
      parse(str) {
        let [day, month, year] = str.split('/')
        return new Date(
          parseInt(year, 10),
          parseInt(month, 10) - 1,
          parseInt(day, 10)
        )
      },
      onDraw(e) {
        e.el.setAttribute('data-month', e.calendars[0].month)
        e.el.classList[isLeapYear(e.calendars[0].year) ? 'add' : 'remove'](
          'is-leapyear'
        )
      },
      onOpen() {
        if (this._o.trigger.hasAttribute('aria-expanded')) {
          this._o.trigger.setAttribute('aria-expanded', 'true')
        }
      },
      onClose() {
        if (this._o.trigger.hasAttribute('aria-expanded')) {
          this._o.trigger.setAttribute('aria-expanded', 'false')
        }
      },
      ...options
    })

    return pika
  })
}

function isLeapYear(year) {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0
}

function isValidDate(d) {
  return d instanceof Date && !isNaN(d)
}



// WEBPACK FOOTER //
// ./src/js/_dp.js